import { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import getAisleBayTextMeQuery from '../queries/aislebay/getAisleBayTextMeQuery';

const useAisleBayTextMe = ({
  itemId,
  storeId,
  aisleBayText,
  phoneNumber,
  isSavingsSubscribed = false,
  ssr = false
}) => {
  let sId = storeId;
  const ctx = useContext(ExperienceContext);
  if (!sId && ctx && ctx.store) {
    sId = ctx.store.storeId;
  }
  const opts = {
    ssr,
    errorPolicy: 'all',
    variables: {
      itemId,
      storeId: sId,
      aisleBayText,
      phoneNumber,
      isSavingsSubscribed
    }
  };
  const MutationQuery = getAisleBayTextMeQuery();
  return useMutation(MutationQuery, opts);
};

export default useAisleBayTextMe;
